import { createReducer, createSlice } from "@reduxjs/toolkit";

const initialState = {
  facetObj: "",
  selectedFactes: "",
  techpubLinks: "",
  emptySearch: false,
};

export const facetFilterReducer = createSlice({
  name: "filterSelectedFacets",
  initialState,
  reducers: {
    getSelectedFilterData: (state, { payload }) => {
      if(payload?.emptySearch) {
        return {
          ...state,
          emptySearch: payload?.emptySearch,
        };
      }
      return {
        facetObj: payload.facetObjectVal,
        selectedFactes: payload?.facetPayloadVal,
        techpubLinks: payload.redirecTechLink,
        emptySearch: false,
      };
    },
  },
});

// export const { getSelectedFilterData } = facetFilterReducer.actions;
export const FacetFilterActions = facetFilterReducer.actions;
